import { entitiyservices, vfappmarket } from '../services.url';

export const MARKETPLACE_MANAGER = {
  GET_USER: (entityUid: string): string => `${entitiyservices}/entities/${entityUid}`,
  PUBLISH_STATUS: (appmarketAppId: string): string =>
    `${vfappmarket}/v1/apps/acquirers/app/${appmarketAppId}`,
};
